import { useRotationStore } from 'src/context/RotationContext';
import { CoatingCompatibility } from 'src/types/ViewModel/Stowage/Product/CoatingCompatibility';
import { Product } from 'src/types/ViewModel/Stowage/Product/Product';

const useUpdateCoatingCompatibilities = () => {
    const { setCoatingCompatibilities } = useRotationStore();

    const updateCoatingCompatibilities = (coatingCompatibilities: CoatingCompatibility[], productList: Product[]) => {
        // Enrich coating compatibilities with product details where available.
        // Records without a matching product (e.g., category-level records with tradeName=null)
        // are still included since they're used for Annex II Chapter 17 category matching.
        const _coatingCompatibilities = coatingCompatibilities.map((cc) => {
            const product = productList.find((p) => p.id === cc.productId);
            return { ...cc, product };
        });
        setCoatingCompatibilities(_coatingCompatibilities);
    };

    return { updateCoatingCompatibilities };
};
export default useUpdateCoatingCompatibilities;
